import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Chat() {
  const region = useSelector((state) => state.region.region);
  const language = useSelector((state) => state.language.language);
  const theme = useSelector((state) => state.theme.theme);
  const relationship = useSelector((state) => state.form.relationship);
  const [verified, setVerified] = useState(false);
  const { t } = useTranslation();

  const navigate = useNavigate();

  // Apply theme to body and set dark background as fallback for mobile
  // Watson on mobile may create a fixed overlay outside the custom element,
  // so the body itself needs the dark background.
  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
    document.body.classList.add('chat-active');
    return () => {
      document.body.classList.remove('chat-active');
    };
  }, [theme]);

  useEffect(() => {
    if (!relationship) {
      navigate('/');
    }
  }, [relationship, navigate]);

  useEffect(() => {
    if (!verified) {
      const existingScript = document.querySelector(`script[src*="WatsonAssistantChatEntry.js"]`);
      if (existingScript) {
        existingScript.parentNode.removeChild(existingScript);
      }
      setVerified(true);
    }
  }, []);


  useEffect(() => {
    if (verified) {
      window.watsonAssistantChatOptions = {
        integrationID: '987d0002-e049-48b2-89d0-54666f2cab58',
        region: 'wxo-au-syd',
        serviceInstanceID: '295771ac-d74d-4be7-a099-462113a456ac',
        element: document.getElementById('watsonChatbot'),
        openChatByDefault: true,
        themeConfig: {
          corners: 'square',
        },
        layout: {
          showFrame: false,
          hasContentMaxWidth: true,
        },
        headerConfig: {
          hideMinimizeButton: true,
        },
        onLoad: async (instance) => {
          const invokeInitial = {
            input: {
              message_type: 'text',
              text: 'initial2'
            }
          };
          const sendInitialParams = {
            input: {
              message_type: 'text',
              text: `idioma: ${language}, style: ${theme}, region: ${region}, relationship: ${relationship}`
            }
          };
          const sendOptions = {
            silent: true
          }
          instance.doAutoScroll();
          instance.restartConversation();
          instance.updateCSSVariables({
          });
          instance.updateMainHeaderTitle('');
          await instance.updateLocale(language);
          await instance.render();
          instance.send(invokeInitial, sendOptions).catch(console.error);
          instance.send(sendInitialParams, sendOptions).catch(console.error);
        }
      };

      const script = document.createElement('script');
      script.src = 'https://web-chat.global.assistant.watson.appdomain.cloud/versions/' + (window.watsonAssistantChatOptions.clientVersion || 'latest') + '/WatsonAssistantChatEntry.js';
      document.head.appendChild(script);
    }

  }, [verified]);

  return (
    <div className="chat-page">
      {/* Glowing orbs */}
      <div className="chat-orb chat-orb-1"></div>
      <div className="chat-orb chat-orb-2"></div>
      <div className="chat-orb chat-orb-3"></div>

      {/* Header bar */}
      <header className="chat-header">
        <button className="chat-back" onClick={() => navigate('/')}>
          <i className="fa-solid fa-arrow-left"></i>
          <span>{t('back_home')}</span>
        </button>
        <div className="chat-header-center">
          <span className="chat-header-brand">{t('title')}</span>
          {relationship && (
            <span className="chat-header-context">
              <i className="fa-solid fa-heart"></i> {relationship}
            </span>
          )}
        </div>
        <div className="chat-header-badge">
          <i className="fa-solid fa-robot"></i> watsonx
        </div>
      </header>

      <div id="watsonChatbot" className="chat-body"></div>
    </div>
  );
}

export default Chat;
